export class DataRequestFields {
  constructor(
    public requestedStartTime: string,
    public requestedEndTime: string,
    public requestedCameraNames: string) { }
}
